import { IScreen } from '@elliemae/ns-schema';
import { PricingSearchConfig, SchemaAndRules } from '@frontend/pricing-search';
import { randomUUID } from '@frontend/utils';

export const EmptySchema: SchemaAndRules = {
  schema: {
    theme: {} as any,
    modules: [],
    screens: [
      {
        type: 'screen_group',
        screens: [
          { id: '46ecfe36-0214-463a-8188-8f7156616bdb' },
          { id: 'b4ecb8fd-e0be-43b0-9e20-1b6b44428359' },
          { id: '1b3baffb-a975-419c-8b24-14f0ae23de1e' },
          { id: '363e772c-515e-49b9-8b5a-7c8ed5c4a5eb' },
        ],
      },
      {
        type: 'screen',
        id: '46ecfe36-0214-463a-8188-8f7156616bdb',
        name: 'General Info',
        fields: [
          { type: 'field_group', name: 'VISIBLE', fields: [] },
          { type: 'field_group', name: 'DETAILED', fields: [] },
        ],
      },
      {
        type: 'screen',
        id: 'b4ecb8fd-e0be-43b0-9e20-1b6b44428359',
        name: 'Finance Info',
        fields: [
          { type: 'field_group', name: 'VISIBLE', fields: [] },
          { type: 'field_group', name: 'DETAILED', fields: [] },
        ],
      },
      {
        type: 'screen',
        id: '1b3baffb-a975-419c-8b24-14f0ae23de1e',
        name: 'Product Info',
        fields: [
          { type: 'field_group', name: 'VISIBLE', fields: [] },
          { type: 'field_group', name: 'DETAILED', fields: [] },
        ],
      },
      {
        type: 'screen',
        id: '363e772c-515e-49b9-8b5a-7c8ed5c4a5eb',
        name: 'Subject Property Info',
        fields: [
          { type: 'field_group', name: 'VISIBLE', fields: [] },
          { type: 'field_group', name: 'DETAILED', fields: [] },
        ],
      },
    ],
  },
  schemaRules: [],
};

export const EmptyScreen: IScreen = {
  type: 'screen',
  id: randomUUID(),
  visible: true,
  name: 'New Section',
  fields: [
    { type: 'field_group', name: 'VISIBLE', fields: [] },
    { type: 'field_group', name: 'DETAILED', fields: [] },
  ],
};
export const EmptyCustomFieldScreen: IScreen = {
  type: 'screen',
  id: randomUUID(),
  visible: true,
  name: 'Custom Fields',
  fields: [{ type: 'field_group', name: 'VISIBLE', fields: [] }],
};

export const SampleConfig: PricingSearchConfig[] = [
  {
    channel: 'Banked - Retail',
    draftSchema: null,
    publishedSchema: null,
    modifiedOn: '0',
    userLastEdited: '',
  },
  {
    channel: 'Banked - Wholesale',
    draftSchema: null,
    publishedSchema: null,
    modifiedOn: '0',
    userLastEdited: '',
  },
  {
    channel: 'Brokered',
    draftSchema: null,
    publishedSchema: null,
    modifiedOn: '0',
    userLastEdited: '',
  },
  {
    channel: 'Correspondent',
    draftSchema: null,
    publishedSchema: null,
    modifiedOn: '0',
    userLastEdited: '',
  },
];
